/**
 * 나눔터 공유 안내 문구·토스트.
 * 라이브러리 상세와 채팅 공유 모달이 같은 문장을 쓴다.
 * 서버 영문 메시지는 토스트에 넣지 않는다.
 */

export const GALLERY_SHARE_COPY = Object.freeze({
  share: '나눔터에 공유',
  sharing: '공유하는 중…',
  shared: '나눔터에 공유됨',
  viewButton: '나눔터에서 보기',
  successToast: '나눔터에 공유했어요',
  failureToast: '나눔터에 공유하지 못했어요. 잠시 후 다시 시도해 주세요',
  viewAction: '보러가기',
});

export const GALLERY_SHARE_TOAST_OPTIONS = Object.freeze({
  bypassLayerQueue: true,
});

export const gallerySharePath = (galleryId) => (
  galleryId
    ? `/library/${encodeURIComponent(galleryId)}?tab=nanumteo`
    : '/library?tab=nanumteo'
);

export const notifyGalleryShareSuccess = (showToast, { galleryId, onView } = {}) => {
  if (typeof showToast !== 'function') return;
  const action = typeof onView === 'function' && galleryId
    ? { label: GALLERY_SHARE_COPY.viewAction, onClick: () => onView(galleryId) }
    : null;
  showToast(
    GALLERY_SHARE_COPY.successToast,
    'success',
    undefined,
    action,
    GALLERY_SHARE_TOAST_OPTIONS,
  );
};

export const notifyGalleryShareFailure = (showToast) => {
  if (typeof showToast !== 'function') return;
  showToast(GALLERY_SHARE_COPY.failureToast, 'error');
};
